import React, { useEffect, useState } from 'react';
import '../CSS/Highlights.css';

const REPORT_TYPE = 'Situational Reports'; // what shows up in SharePoint (keep it simple)

function logHighlightClick(reportName) {
  const userEmail = localStorage.getItem('user-email');
  if (!userEmail) return;

  const payload = { reportName, reportType: REPORT_TYPE, userEmail };

  try {
    // Prefer Beacon so it survives new-tab navigation
    if (navigator.sendBeacon) {
      const blob = new Blob([JSON.stringify(payload)], { type: 'application/json' });
      navigator.sendBeacon('/api/log-report', blob);
    } else {
      // Fallback
      fetch('/api/log-report', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        keepalive: true,
        body: JSON.stringify(payload)
      }).catch(() => {});
    }
  } catch {}
}

const Highlights = () => {
  const [Spotlight, setSpotlight] = useState([]);
  const [searchTerm, setSearchTerm] = useState('');
  const [filteredData, setFilteredData] = useState([]);
  const [loading, setLoading] = useState(true);

  // Keep your existing proxy URL builder exactly as-is (it works)
  const addProxyUrls = (items) => {
    return (items || []).map(item => ({
      ...item,
      proxyUrl: `/api/highlights/Spotlight/${encodeURIComponent(item.name)}.pdf`
    }));
  };

  useEffect(() => {
    let mounted = true;
    fetch('/api/hello')
      .then((r) => r.json())
      .then((data) => {
        if (!mounted) return;
        const spotlightWithProxy = addProxyUrls(data.Spotlight);
        setSpotlight(spotlightWithProxy);
        setFilteredData(spotlightWithProxy);
      })
      .catch((err) => console.error('Error fetching reports data:', err))
      .finally(() => mounted && setLoading(false));
    return () => { mounted = false; };
  }, []);

  const handleSearch = (e) => {
    const term = e.target.value;
    setSearchTerm(term);
    if (term.trim()) {
      const t = term.toLowerCase();
      setFilteredData(Spotlight.filter((item) => item.name.toLowerCase().includes(t)));
    } else {
      setFilteredData(Spotlight);
    }
  };

  if (loading) {
    return (
      <div className="highlights">
        <h1>Situational Reports</h1>
        <p>Loading…</p>
      </div>
    );
  }

  return (
    <div className="highlights">
      <h1>Situational Reports</h1>

      <div className="box">
        <p>
            In-depth intelligence reports encompassing detailed analyses of notable incidents,
            ongoing campaigns, developments within activist organizations, strategic tactics employed,
            and related subjects, providing a comprehensive understanding of the landscape and trends
            in activist activities.
        </p>
      </div>

      {/* Search input */}
      <label>
        Search:&nbsp;
        <input
          type="text"
          placeholder="Search by title"
          value={searchTerm}
          onChange={handleSearch}
        />
      </label>

      <ul className="list-item">
        {filteredData.map((item, index) => (
          <li key={item.id || index}>
            <a
              href={item.proxyUrl}                // ✅ keep native navigation
              target="_blank"
              rel="noopener noreferrer"
              onClick={() => {
                // Pass a clean title to SharePoint (strip trailing .pdf if present)
                const cleanName = (item.name || '').replace(/\.pdf$/i, '');
                logHighlightClick(cleanName);
              }}
            >
              {item.name}
            </a>
          </li>
        ))}
      </ul>

      {filteredData.length === 0 && <p>No reports found.</p>}
    </div>
  );
};

export default Highlights;
